export enum CongressKeysEnum {
  Modality = 'MODALITY',
  Courses = 'COURSES',
  Hotel = 'HOTEL',
}